import React from 'react';
import { FiSmartphone } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const DownloadAppButton = ({ className, compact = false }) => {
  const handleDownload = () => {
    // Construct URL with ?mode=native
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('mode', 'native');

    // Open in new tab to simulate "launching" the app
    window.open(currentUrl.toString(), '_blank');
  };

  if (compact) {
    return (
      <button
        onClick={handleDownload}
        className={`flex items-center justify-center w-full text-left px-4 py-2 text-sm text-charcoal-700 dark:text-charcoal-300 hover:bg-charcoal-100 dark:hover:bg-charcoal-800 transition-colors ${className}`}
        role="menuitem"
      >
        <SafeIcon icon={FiSmartphone} className="mr-3 text-lg" />
        <span>Companion App</span>
      </button>
    );
  }

  return (
    <button
      onClick={handleDownload}
      className={`transition-colors ${className}`}
    >
      Get App
    </button>
  );
};

export default DownloadAppButton;
